import { createContext } from '@lit/context'
import { AddToBasketSuccess, AddToBasketFailure } from 'components/ordering/add-to-basket/basket-parser.js'
import { StepDataDTO } from 'components/ordering/configurator/api/dtos/step-data-dto.js'
import { StepSelectionData } from 'components/ordering/configurator/api/dtos/step-selection-data.js'
import { SummaryDTO } from 'components/ordering/configurator/api/dtos/summary-dto.js'
import { VariantDataDTO } from 'components/ordering/configurator/api/dtos/variant-data-dto.js'


export class NotFetchedYet {
  notFetchedYetBrand = Symbol('NOT_FETCHED_YET_BRAND')
}


export type ConfiguratorProductContext = { id: number } | NotFetchedYet
export type ConfiguratorProductContextKey = 'CONFIGURATOR_PRODUCT_CONTEXT'
const configuratorProductContextKey: ConfiguratorProductContextKey = 'CONFIGURATOR_PRODUCT_CONTEXT'
export const configuratorProductContext = createContext<ConfiguratorProductContext>(configuratorProductContextKey)

export type ConfiguratorSummaryContext = SummaryDTO | NotFetchedYet
export type ConfiguratorSummaryContextKey = 'CONFIGURATOR_SUMMARY_CONTEXT'
const configuratorSummaryContextKey: ConfiguratorSummaryContextKey = 'CONFIGURATOR_SUMMARY_CONTEXT'
export const configuratorSummaryContext = createContext<ConfiguratorSummaryContext>(configuratorSummaryContextKey)

export type ConfiguratorCompletedContext = boolean | NotFetchedYet
export type ConfiguratorCompletedContextKey = 'CONFIGURATOR_COMPLETED_CONTEXT'
const configuratorCompletedContextKey: ConfiguratorCompletedContextKey = 'CONFIGURATOR_COMPLETED_CONTEXT'
export const configuratorCompletedContext = createContext<ConfiguratorCompletedContext>(configuratorCompletedContextKey)

export type ConfiguratorStepsContext = StepDataDTO[] | NotFetchedYet
export type ConfiguratorStepsContextKey = 'CONFIGURATOR_STEPS_CONTEXT'
const configuratorStepsContextKey: ConfiguratorStepsContextKey = 'CONFIGURATOR_STEPS_CONTEXT'
export const configuratorStepsContext = createContext<ConfiguratorStepsContext>(configuratorStepsContextKey)

export type ConfiguratorDataContext = Record<string, StepSelectionData> | NotFetchedYet
export type ConfiguratorDataContextKey = 'CONFIGURATOR_DATA_CONTEXT'
const configuratorDataContextKey: ConfiguratorDataContextKey = 'CONFIGURATOR_DATA_CONTEXT'
export const configuratorDataContext = createContext<ConfiguratorDataContext>(configuratorDataContextKey)

export type ConfiguratorGroupsContext = Record<string, boolean> | NotFetchedYet
export type ConfiguratorGroupsContextKey = 'CONFIGURATOR_GROUPS_CONTEXT'
const configuratorGroupsContextKey: ConfiguratorGroupsContextKey = 'CONFIGURATOR_GROUPS_CONTEXT'
export const configuratorGroupsContext = createContext<ConfiguratorGroupsContext>(configuratorGroupsContextKey)

export type ConfiguratorVariantDataContext = VariantDataDTO | null | NotFetchedYet
export type ConfiguratorVariantDataContextKey = 'CONFIGURATOR_VARIANT_DATA_CONTEXT'
const configuratorVariantDataContextKey: ConfiguratorVariantDataContextKey = 'CONFIGURATOR_VARIANT_DATA_CONTEXT'
export const configuratorVariantDataContext = createContext<ConfiguratorVariantDataContext>(configuratorVariantDataContextKey)

export type ConfiguratorUrlContext = string | null | NotFetchedYet
export type ConfiguratorUrlContextKey = 'CONFIGURATOR_URL_CONTEXT'
const configuratorUrlContextKey: ConfiguratorUrlContextKey = 'CONFIGURATOR_URL_CONTEXT'
export const configuratorUrlContext = createContext<ConfiguratorUrlContext>(configuratorUrlContextKey)

export type ConfiguratorAdditionalTextsContext = Record<string, string> | NotFetchedYet
export type ConfiguratorAdditionalTextsContextKey = 'CONFIGURATOR_ADDITIONAL_TEXTS_CONTEXT'
const configuratorAdditionalTextsContextKey: ConfiguratorAdditionalTextsContextKey = 'CONFIGURATOR_ADDITIONAL_TEXTS_CONTEXT'
export const configuratorAdditionalTextsContext = createContext<ConfiguratorAdditionalTextsContext>(configuratorAdditionalTextsContextKey)

export type UpdateStepSelectionContext = (stepKey: string, stepData: StepSelectionData) => Promise<void>
export type UpdateStepSelectionContextKey = 'UPDATE_STEP_SELECTION_CONTEXT'
const updateStepSelectionContextKey: UpdateStepSelectionContextKey = 'UPDATE_STEP_SELECTION_CONTEXT'
export const updateStepSelectionContext = createContext<UpdateStepSelectionContext>(updateStepSelectionContextKey)

export type AddToBasketContext = () => Promise<AddToBasketSuccess | AddToBasketFailure>
export type AddToBasketContextKey = 'ADD_TO_BASKET_CONTEXT'
const addToBasketContextKey: AddToBasketContextKey = 'ADD_TO_BASKET_CONTEXT'
export const addToBasketContext = createContext<AddToBasketContext>(addToBasketContextKey)
